import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesPermissionsComponent } from './roles-permissions.component';
import { RolesPermissionsListComponent } from './roles-permissions-list/roles-permissions-list.component';
import { RolesPermissionsDetailsComponent } from './roles-permissions-details/roles-permissions-details.component';
import { FormsModule } from '@angular/forms';
import {
	KngButtonModule,
	ModalModule,
	KngFooterModule,
	KngFooterService,
	KngToasterModule,
	KngLoaderModule
} from 'kinetic-angular';
import { RolesPermissionsService } from './roles-permissions.service';
import { ToastrModule } from 'ngx-toastr';
import { AnalyticsModule } from '../../services/analytics/analytics.module';
import { TextAreaAutoSizeDirectiveModule } from '../../services/shared/directives/text-area-auto-size.directive';
import { ShellService } from '../shell/shell.service';

@NgModule({
	declarations: [
		RolesPermissionsComponent,
		RolesPermissionsListComponent,
		RolesPermissionsDetailsComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		KngButtonModule,
		ModalModule,
		KngToasterModule,
		KngFooterModule,
		AnalyticsModule,
		ToastrModule.forRoot({
			preventDuplicates: true,
			closeButton: true
		}),
		TextAreaAutoSizeDirectiveModule,
		KngLoaderModule
	],
	exports: [RolesPermissionsComponent],
	providers: [ RolesPermissionsService, KngFooterService, ShellService ]
})
export class RolesPermissionsModule {}
